module.exports = __webpack_public_path__ + "img/icon-72x72.b6ae507d.png";